import Api from '../Api';

import { url } from './config';
import { CommissionType } from './types';

const api = new Api<CommissionType>(url);

export default api;
